<template>
    <div class="row">
        <go-lotus-side-menu
            :side-menu-items="menuItems"
            @set-parent-prop="propSetFromChild($event)"
        >
        </go-lotus-side-menu>

        <div class="col-12 col-md-10 main-content position-relative">
            <transition name="simple-fade" mode="out-in">
                <component
                    :is="component"
                    @set-parent-prop="propSetFromChild($event)"
                    :patient="patient"
                ></component>
            </transition>
        </div>
    </div>
</template>

<script>
import GoLotusSideMenu from "./GoLotusSideMenu";
import AboutHistory from "./treatment-plan/AboutHistory";
import Documentation from "./treatment-plan/Documentation";
import Timeline from "./treatment-plan/Timeline";

import { sideMenuItems } from "../plugins/sideMenuItems";

export default {
    name: "TreatmentPlan",
    props: ["patientId"],
    components: {
        GoLotusSideMenu,
        AboutHistory,
        Documentation,
        Timeline,
    },
    mixins: [sideMenuItems],

    data() {
        return {
            component: "timeline",
            menuItems: [
                { title: "About/History", class: "", component: "about-history" },
                { title: "Timeline", class: "", component: "timeline" },
                { title: "Documentation", class: "", component: "documentation" },
            ],
            patient: {},
        };
    },
    created() {
        this.getPatient();
    },
    mounted() {},
    methods: {
        getPatient() {
            axios.get(`/api/patients/${this.patientId}`).then(response => {
                this.patient = response.data.data;
            });
        },
    },
};
</script>

<style scoped lang="scss"></style>
